/**
 * Attachments Section Component
 * Displays file attachments for a proposal
 */
export function AttachmentsSection({ attachments, compact = false }) {
  if (!attachments || attachments.length === 0) {
    return null;
  }

  // Get file icon based on file type
  const getFileIcon = (fileType) => {
    if (!fileType) return '📄';

    if (fileType.includes('pdf')) return '📕';
    if (fileType.includes('image')) return '🖼️';
    if (fileType.includes('word') || fileType.includes('doc')) return '📘';
    if (fileType.includes('excel') || fileType.includes('sheet')) return '📗';
    if (fileType.includes('powerpoint') || fileType.includes('presentation')) return '📙';
    if (fileType.includes('zip') || fileType.includes('archive')) return '🗜️';
    if (fileType.includes('video')) return '🎬';
    if (fileType.includes('audio')) return '🎵';

    return '📄';
  };

  // Format file size
  const formatFileSize = (bytes) => {
    if (!bytes) return '';

    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1048576) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / 1048576).toFixed(1)} MB`;
  };

  if (compact) {
    return (
      <div className="t24-attachments-compact">
        <span className="attachments-icon">📎</span>
        <span className="attachments-count">{attachments.length} file{attachments.length > 1 ? 's' : ''}</span>
      </div>
    );
  }

  return (
    <div className="t24-attachments-section">
      <h3 className="attachments-title">
        <span className="attachments-icon">📎</span>
        Attachments ({attachments.length})
      </h3>

      <div className="attachments-list">
        {attachments.map((file, index) => (
          <div key={index} className="attachment-item">
            <span className="file-icon">{getFileIcon(file.type || file.mime_type)}</span>

            <div className="file-info">
              <div className="file-name">{file.name || file.filename || 'Untitled'}</div>
              {file.size && (
                <div className="file-size">{formatFileSize(file.size)}</div>
              )}
            </div>

            {file.url && (
              <a
                href={file.url}
                className="file-download"
                download
                onClick={(e) => e.stopPropagation()}
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="download-icon">⬇️</span>
                Download
              </a>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
